import { Box } from "@mui/material";
import { ReactComponent as NonIdealIcon } from "../../../assets/icons/draft_non_ideal_icon.svg";
import styles from "./styles.module.css";
import { ParagraphText, UBButton } from "../../../Libraries";
import { analytics, triggerLogEvent } from "../../../config/firebase";

/** title / subTitle accept strings or React nodes (JSX: <b>, <a>, fragments, etc.) */
const FilterNonIdeal = ({
  icon = <NonIdealIcon />,
  title,
  subTitle,
  subTitleText = "",
  subTitleTextOnClick = () => {},
  subTitleTextId = "filter_non_ideal_subtitle_text_btn",
  onBack,
  buttonTitle = 'Back',
  buttonClassName,
  buttonId,
  children,
}) => {
  const hasTitle =
    title != null &&
    title !== false &&
    (typeof title !== "string" || title.trim() !== "");

  const hasSubTitle =
    subTitle != null &&
    subTitle !== false &&
    (typeof subTitle !== "string" || subTitle.trim() !== "");

  const useLegacySubTitleLink = Boolean(
    subTitleText && String(subTitleText).trim(),
  );

  return (
    <Box className={styles.nonIdealContainer}>
      {hasTitle && (
        <ParagraphText className={styles.title}>{title}</ParagraphText>
      )}
      {hasSubTitle && (
        <ParagraphText className={styles.subTitle}>
          {useLegacySubTitleLink ? (
            <span>
              {subTitle}
              <span
                id={subTitleTextId}
                onClick={subTitleTextOnClick}
                className={styles.underline}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    subTitleTextOnClick();
                  }
                }}
              >
                {subTitleText}
              </span>
            </span>
          ) : (
            subTitle
          )}
        </ParagraphText>
      )}
      {typeof onBack === "function" && (
        <UBButton
          id={buttonId || "filter_non_ideal_action_btn"}
          title={buttonTitle}
          onClick={() => { triggerLogEvent(analytics, "filter_cleared"); onBack(); }}
          className={
            buttonClassName ||
            `textUppercase foundationBlueNormalBg foundationWhite fontSize14 marginTop25 marginBottom15`
          }
        />
      )}
      {children}
    </Box>
  );
};
export default FilterNonIdeal;
